module.exports = __webpack_public_path__ + "img/ics_o_document_gray.d116f3f4.svg";